import "../sass/especiales.scss";

import { ET_FX } from "./utils/FX.js";

import "./blocks/map.js";
import "./blocks/dropdowns.js";

var especial = new ET_Especiales();

$(document).ready(function () {
	especial.init();
});

$(document).scroll(function () {
	especial.controlScroll();
});

function ET_Especiales() {}

ET_Especiales.prototype.init = function () {
	var fx = new ET_FX();
	fx.init();
};

ET_Especiales.prototype.controlScroll = function () {
	var _top = 60;

	if ($(window).scrollTop() > _top) {
		$("#redux-especial-header").addClass("desplegado");
	} else {
		$("#redux-especial-header").removeClass("desplegado");
	}
};
